var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.menuContentHolder
    ? _c(
        "div",
        { staticClass: "container" },
        [
          _vm.megaMenu
            ? [
                _vm.menuStyle === "desktop"
                  ? _c(
                      "div",
                      { staticClass: "mega-region-display" },
                      [
                        _c("content-menu-mega-desktop", {
                          attrs: {
                            "menu-content": _vm.menuContent["Menu Items"],
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.menuStyle === "mobile"
                  ? _c(
                      "div",
                      { staticClass: "mega-region-display visible" },
                      [
                        _c("content-menu-mega-desktop", {
                          attrs: {
                            "menu-content": _vm.menuContent["Menu Items"],
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _vm.menuStyle === "desktop"
                  ? [
                      _c("content-menu-editor-desktop", {
                        attrs: {
                          "menu-content": _vm.menuContent,
                          "menu-direction": _vm.menuDirection,
                        },
                      }),
                    ]
                  : _vm.menuStyle === "mobile"
                  ? [
                      _c("content-menu-editor-mobile", {
                        attrs: { "menu-content": _vm.menuContent },
                      }),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }